import {SearchInCurrentRun} from "../UserView/Search/SearchInCurrentRun";

export class SearchInCurrentRunAdapter {
    constructor(imageViewer) {
        this._imageViewer = imageViewer;
    }

    addSearchHandlerSchemaTo(searchContext) {
        const props = this._imageViewer.props;

        const isProcessingResult = props.location.pathname.indexOf('/explore_results/') !== -1;

        if (!isProcessingResult) {
            return;
        }

        const runId = props.parentProps.match.params.runId;

        const origin = new SearchInCurrentRun(
            this._imageViewer,
            runId,
            props.location,
            props.history
        );

        origin.addSearchHandlerSchemaTo(searchContext);
    }
}